import { config } from "../env";
import { get, patch, post } from "./helpers/http-handler";

export const adminGetAuditDashboardInfo = (payload: object) =>
  post(`${config.API_URL}/vendor-checkpoint/dashboard-info`, payload);

export const adminGetAuditList = (queryRequest: string) =>
  get(`${config.API_URL}/vendor-checkpoint/by-vendor?${queryRequest}`);

export const adminUpdateAudit = (id: string, payload: object) =>
  patch(`${config.API_URL}/vendor-checkpoint/bulk/submission`, payload);

export const adminGetAllAuditList = (queryRequest: string) =>
  get(`${config.API_URL}/vendor-checkpoint?${queryRequest}`);

export const vendorAuditChecklist = (queryRequest: string) =>
  get(
    `${config.API_URL}/vendor-checkpoint/vendor-audit/checklist?${queryRequest}`,
  );

export const getVendorFilterLocation = (queryRequest: string) =>
  get(`${config.API_URL}/vendor-checkpoint/filter/locations?${queryRequest}`);

export const getVendorFilterLegislation = (queryRequest: string) =>
  get(
    `${config.API_URL}/vendor-checkpoint/filter/legislations?${queryRequest}`,
  );

export const getManageAuditScore = (queryRequest: string) =>
  get(`${config.API_URL}/vendor-checkpoint/audit/score?${queryRequest}`);

export const getManageAuditScoreFilter = (queryRequest: string) =>
  get(`${config.API_URL}/vendor-checkpoint/audit/score/filter?${queryRequest}`);

export const generateManageAuditVendorReport = (payload: object) =>
  post(`${config.API_URL}/reports/vendor-audit-score`, payload);

export const exportVendorComplianceMaster = (queryRequest: string) =>
  get(
    `${config.API_URL}/vendor-checkpoint/export/vendor/compliace/data?${queryRequest}`,
  );

export const downloadVendorComplianceMaster = (payload: string) =>
  post(`${config.API_URL}/reports/export-vendor-compliance`, payload);

export const exportManageAudit = (queryRequest: string) =>
  get(
    `${config.API_URL}/vendor-checkpoint/export/managa-audit?${queryRequest}`,
  );

export const downloadVendorComplianceAuditScore = (payload: string) =>
  post(`${config.API_URL}/reports/vendor-audit-score-site-level`, payload);

export const getManageAuditVendorSiteMis = (queryRequest: string) =>
  get(`${config.API_URL}/vendors/manage/vendor/report?${queryRequest}`);

export const getManageAuditVendorComplianceScoreCard = (queryRequest: string) =>
  get(`${config.API_URL}/vendor-checkpoint/audit/report?${queryRequest}`);

export const downloadManageAuditSiteMis = (payload: any) =>
  post(
    `${config.API_URL}/reports/vendor-manage-audit-site-mis-report`,
    payload,
  );

export const downloadManageAuditComplianceScoreCard = (payload: string) =>
  post(`${config.API_URL}/reports/vendor-manage-vendor-score-report`, payload);

export const downloadVendorWiseAuditScore = (payload: string) =>
  post(`${config.API_URL}/reports/vendor-audit-score-vendor-level`, payload);

export const getManageAuditVendorWiseTrendsPanIndia = (queryRequest: string) =>
  get(
    `${config.API_URL}/vendor-checkpoint/audit/vendor-wise/trends/report?${queryRequest}`,
  );

export const downloadManageAuditVenderWiseTrendsPanIndia = (payload: string) =>
  post(
    `${config.API_URL}/reports/vendor-wise-audit-trends-pan-india-report`,
    payload,
  );

export const getRepeatErrorsandPeriodicity = (queryRequest: string) =>
  get(
    `${config.API_URL}/vendor-checkpoint/audit/repeat-error-periodicity/non-compliance-report?${queryRequest}`,
  );

export const downloadManageRepeatError = (payload: string) =>
  post(
    `${config.API_URL}/reports/repeat-error-periodicity-non-compliance-report`,
    payload,
  );

export const getAuditStatusFilter = (queryRequest: string) =>
  get(
    `${config.API_URL}/vendor-checkpoint/audit/status/list/filter?${queryRequest}`,
  );

export const getDataAuditStatusList = (queryRequest: string) =>
  get(`${config.API_URL}/vendor-checkpoint/audit/status/list?${queryRequest}`);

export const getDataAuditStatusTaskList = (queryRequest: string) =>
  get(
    `${config.API_URL}/vendor-checkpoint/audit/status/task/list?${queryRequest}`,
  );

export const downloadAuditStatus = (payload: string) =>
  post(`${config.API_URL}/reports/audit-status`, payload);

export const getAuditStatusTaskFilterList = (queryRequest: string) =>
  get(
    `${config.API_URL}/vendor-checkpoint/audit/status/task/filter?${queryRequest}`,
  );

export const getMISSiteMgmt = (queryRequest: string) =>
  get(`${config.API_URL}/vendor-checkpoint/site-mgmt/report?${queryRequest}`);

export const downloadSiteMGMT = (payload: any) =>
  post(`${config.API_URL}/reports/site-management/report`, payload);

export const getManageAuditScoreReport = (queryRequest: string) =>
  get(`${config.API_URL}/vendor-checkpoint/audit/score/report?${queryRequest}`);

export const getMISLineItemWise = (queryRequest: string) =>
  get(`${config.API_URL}/vendor-checkpoint/line-item/mis?${queryRequest}`);

export const getMISLineItemWiseDetail = (queryRequest: string) =>
  get(
    `${config.API_URL}/vendor-checkpoint/line-item/mis/detail?${queryRequest}`,
  );

export const downloadMISReport = (payload: any) =>
  post(`${config.API_URL}/reports/audit-score/mis/report`, payload);

export const getMISDetails = (queryRequest: string) =>
  get(`${config.API_URL}/vendor-checkpoint/mis/detail?${queryRequest}`);

export const downloadMISLineItemReport = (payload: any) =>
  post(`${config.API_URL}/reports/line-item/mis`, payload);

export const getLineItemReportList = (queryRequest: string) =>
  get(`${config.API_URL}/vendor-checkpoint/line-item/report?${queryRequest}`);

export const downloadMLineItemReport = (payload: any) =>
  post(`${config.API_URL}/reports/line-item/report`, payload);

export const downloadRetrificationReport = (payload: any) =>
  post(`${config.API_URL}/reports/audit-mis-report`, payload);
///api/v1/vendor-checkpoint/line-item/mis

export const auditReportSummary = (payload: any) =>
  post(`${config.API_URL}/reports/audit-report-summary`, payload);

export const vendorAuditOverview = (payload: any) =>
  post(`${config.API_URL}/reports/vendor-audit-overview`, payload);
